import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Button, Divider, Input, Icon, Radio, Alert, message } from "antd";
//refresh token
import { CognitoUserPool } from "amazon-cognito-identity-js";
import AWS from "aws-sdk";
// display offline message (if internet gets disconnected)
// import { Offline } from "react-detect-offline";

import variables from "../../variables.scss";
import icon_anchor from "../../assets/images/icon_anchor.png";
import icon_user from "../../assets/images/icon_user.png";
import icon_info from "../../assets/images/icon_info.png";
import icon_stop from "../../assets/images/icon_stop.png";
import icon_stop_inactive from "../../assets/images/icon_stop_inactive.png";
import constants from "../../configs/constants";
import { useSelector, useDispatch } from "react-redux";
import Checkbox from "../Checkbox";
import moment from "moment";
import { sortByKey } from "../../configs/utils";
import { wsConnect, wsDisconnect, wsSend } from "../../store/pushback";
import { updateUser, restoreSession, exportTokenInfo } from "../../store/session";
import FlipMove from "react-flip-move";
import ModalInformation from "../ModalInformation";
import { SearchOutlined } from "@ant-design/icons";
import app_logo from "../../assets/images/app_logo.png";

const icon_profile_svg = require("../../assets/images/icon_profile.svg");
const icon_information_svg = require("../../assets/images/icon_information.svg");
const icon_stop_inactive_svg = require("../../assets/images/icon_stop_inactive.svg");
const icon_stop_svg = require("../../assets/images/icon_stop.svg");
const styles = {
  container: {
    minHeight: "100vh",
    padding: "170px 20px 30px 20px",
  },
  row: {
    color: `${variables.appColor}`,
    boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.3)",
    textAlign: "center",
    background: "#2B2C41",
    marginBottom: "1em",
    fontSize: 14,
  },
  divider: {
    background: "rgba(255, 255, 255, 0.5)",
    height: 16,
    top: 0,
  },
};

const ATCO = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.session.user);
  const wsOpened = useSelector((state) => state.pushback.wsOpened);
  const gatesData = useSelector((state) => state.pushback.gatesData);
  const pushbackMapping = useSelector((state) => state.session.pushbackMapping);
  const tokenInfo = useSelector((state) => state.session.tokenInfo);
  const tokenInfoError = useSelector((state) => state.session.tokenInfoError);
  const airlineCodeMapping = useSelector(
    (state) => state.session.airlineCodeMapping
  );
  const [pushbackData, setPushbackData] = useState();
  const [originalPushbackData, setOriginalPushbackData] = useState([]);
  const [gmcAllChecked, setGMCAllChecked] = useState(false);
  const [gmc1Checked, setGMC1Checked] = useState(false);
  const [gmc2Checked, setGMC2Checked] = useState(false);
  const [gmc3Checked, setGMC3Checked] = useState(false);
  const [gmc4Checked, setGMC4Checked] = useState(false);
  const [gmc5Checked, setGMC5Checked] = useState(false);
  const [gmc6Checked, setGMC6Checked] = useState(false);
  const [sortKey, setSortKey] = useState("S");
  const [searchValue, setSearchValue] = useState("");
  const [infoModalVisibility, setInfoModalVisibility] = useState(false);
  const [userLocal, setUserLocal] = useState(
    JSON.parse(localStorage.getItem("atcoToken"))
  );
  const [userGMC, setUserGMC] = useState(
    JSON.parse(localStorage.getItem("filterQuery"))
  );

  const [loading, setLoading] = useState(false);
  const [errorDisplay, setErrorDisplay] = useState(false);
  const [errorSessionDisplay, setErrorSessionDisplay] = useState(false);
  const [selectedBay, setSelectedBay] = useState();
  const [selectedClass, setSelectedClass] = useState(false);
  const [checkConnection, setCheckConnection] = useState(false);

  //refs
  const ref_pushback_instruction = useRef();

  useEffect(() => {

    // run encryptToken API

    const getAccessTokenLocal = window.localStorage.getItem("accessToken");

    if (getAccessTokenLocal) {
      setTimeout(() => {
        dispatch(exportTokenInfo({access_token: getAccessTokenLocal}));
      }, 1000);
    }
    
    
  }, []);

  useEffect(() => {
    if (tokenInfoError) {
      console.log('tokenInfoError', tokenInfoError);
      message.error(tokenInfoError);
    }
  }, [tokenInfoError]);

  // export token API error 400, 500, 403, 502
  useEffect(() => {
    if (tokenInfo && tokenInfo.message) {
      console.log('tokenInfo', tokenInfo);
      if (tokenInfo.message === 'access_token parameter is missing.') {
        message.error('Missing required parameter. Please supply the missing parameter.');
      } else {
        message.error(tokenInfo.message);
      }
      
    }
  }, [tokenInfo]);


  useEffect(() => {
    if (user && tokenInfo) {
      let token = tokenInfo.encrypted_access_token;
      console.log('tokenInfo 1');
      // let websocketURL = constants.SOCKET_ROOT_URL + user.accessToken.jwtToken;
      let websocketURL = constants.SOCKET_ROOT_URL +encodeURIComponent(token);
      dispatch(wsConnect(websocketURL));
      // console.log("ACTO user", user);
    }
  }, [user, tokenInfo]);

  useEffect(() => {
    if (loading) {
      console.log("loading", loading);
    }
  }, [loading]);

  // on load from local storage
  useEffect(() => {
    if (userLocal) {
      console.log("RESTORE SESSION");
      dispatch(restoreSession());

      if (tokenInfo) {
        let token = tokenInfo.encrypted_access_token;

        //once user successfully logged in connect with web socket
        const getToken = window.localStorage.getItem("accessToken");
        // let websocketURL = constants.SOCKET_ROOT_URL + getToken;
        let websocketURL = constants.SOCKET_ROOT_URL + encodeURIComponent(token);
        console.log('tokenInfo 2');

        dispatch(wsConnect(websocketURL));

        //store the userlocal from the local storage to the user store
        dispatch(updateUser(userLocal));
        // console.log("TTime Atco user", userLocal);

      }
      
    }
  }, []);

  useEffect(() => {
    if (wsOpened) {
      dispatch(wsSend({ action: constants.ACTION_GET_GATES_DATA }));
      setInterval(() => {
        console.log("Heartbeat: fetch gates data");
        dispatch(wsSend({ action: constants.ACTION_GET_GATES_DATA }));
        setErrorDisplay(true);
      }, constants.HEARTBEAT_INTERVAL);
    }
  }, [wsOpened]);

  useEffect(() => {
    if (gatesData) {
      let filteredGatesData = gatesData.filter((el) => {
        let limit = moment().add(constants.TIME_CAP, "minutes");
        // let startupapproval_datetime = moment(
        //   el.startupapproval_date + " " + el.startupapproval_time,
        //   "YYYY-MM-DD HH:mm"
        // );

        let targeted_offblock_datetime = "";

        if (el.targeted_offblock_date) {
          targeted_offblock_datetime = moment(
            el.targeted_offblock_date + " " + el.targeted_offblock_time,
            "YYYY-MM-DD HH:mm"
          );
        } else {
          targeted_offblock_datetime = moment(
            el.scheduled_date + " " + el.scheduled_time,
            "YYYY-MM-DD HH:mm"
          );
        }

        return (
          // el.delete_marker === "N" &&
          el.is_deleted === "False" &&
          limit.diff(targeted_offblock_datetime, "minutes") >= 0 &&
          (!el.airborne_date && !el.airborne_time ||
            el.airborne_date === '' && el.airborne_time === '' )
        );
      });

      let pbdata = filteredGatesData.map((e) => {
        let pbrow = {};
        let airlineCodeDtls = airlineCodeMapping.data.filter(
          (a) => a.IATA == e.airline_code
        );
        if (airlineCodeDtls.length > 0) {
          pbrow.call_sign = e.flightno.replace(
            e.airline_code,
            airlineCodeDtls[0].ICAO
          );
        } else {
          pbrow.call_sign = e.flightno;
        }
        pbrow.bay = e.current_parkingstand;
        if (e.startupapproval_time) {
          pbrow.startupapproval_time =
            // e.startupapproval_time.substring(0, 2) +
            // ":" +
            // e.startupapproval_time.substring(2, 4);
          pbrow.startupapproval_time =
            e.startupapproval_time.substring(0, 2) +
            ":" +
            e.startupapproval_time.substring(3, 5);
        } else {
          pbrow.startupapproval_time = "";
        }
        pbrow.status = "";
        pbrow.sortkey_status = 0;
        pbrow.sortkey_action = "1900-01-01 01:00:00";
        pbrow.sortkey_driver = "1900-01-01 01:00:00";
        pbrow.sortkey_action_date = "1900-01-01 01:00:00";

        //command from ATC
        pbrow.pushback_instruction_atc = "";
        if (e.pushback_instruction_atc) {
          pbrow.pushback_instruction_atc = e.pushback_instruction_atc;
        }

        //command from driver
        pbrow.pushback_instruction_driver = "";
        if (e.pushback_instruction_driver) {
          pbrow.pushback_instruction_driver = e.pushback_instruction_driver;
        }

        pbrow.pushback_confirmation_status = e.pushback_confirmation_status;
        if (
          !e.pushback_confirmation_status &&
          (e.technical_flight_status1 === "ES" ||
            e.technical_flight_status1 === "GA" ||
            e.technical_flight_status1 === "GO" ||
            e.technical_flight_status1 === "OB" ||
            e.technical_flight_status1 === "BD" ||
            e.technical_flight_status1 === "FC" ||
            e.technical_flight_status1 === "LC")
        ) {
          pbrow.status = "G";
          pbrow.sortkey_status = 7;
        } else if (
          !e.pushback_confirmation_status &&
          e.technical_flight_status1 != "ES" &&
          e.technical_flight_status1 != "GA" &&
          e.technical_flight_status1 != "GO" &&
          e.technical_flight_status1 != "OB" &&
          e.technical_flight_status1 != "BD" &&
          e.technical_flight_status1 != "FC" &&
          e.technical_flight_status1 != "LC"
        ) {
          pbrow.status = "P";
          pbrow.sortkey_status = 7;
        } else if (e.pushback_confirmation_status === "PENDING_DRIVER") {
          if (
            (pbrow.pushback_instruction_atc &&
              !pbrow.pushback_instruction_driver) ||
            (pbrow.pushback_instruction_atc &&
              pbrow.pushback_instruction_driver === "ABORT")
          ) {
            pbrow.status = "D";
            pbrow.sortkey_status = 8;
          } else if (
            pbrow.pushback_instruction_driver !== pbrow.pushback_instruction_atc
          ) {
            pbrow.sortkey_status = 10;
            pbrow.status = "M";
          } else if (
            pbrow.pushback_instruction_driver == pbrow.pushback_instruction_atc
          ) {
            pbrow.status = "V";
            pbrow.sortkey_status = 6;
          }
        } else if (
          e.pushback_confirmation_status === "CONTINUE" ||
          e.pushback_confirmation_status === "PENDING_ATCO"
        ) {
          // pbrow.status = "C";
          // pbrow.sortkey_status = 9;
          if (
            pbrow.pushback_instruction_driver &&
            !pbrow.pushback_instruction_atc
          ) {
            pbrow.sortkey_status = 9;
            pbrow.status = "C";
          } else if (
            pbrow.pushback_instruction_driver &&
            pbrow.pushback_instruction_atc === "ABORT"
          ) {
            pbrow.status = "C";
            pbrow.sortkey_status = 9;
          } else if (
            pbrow.pushback_instruction_driver == pbrow.pushback_instruction_atc
          ) {
            pbrow.status = "V";
            pbrow.sortkey_status = 6;
          } else if (
            pbrow.pushback_instruction_driver !== pbrow.pushback_instruction_atc
          ) {
            pbrow.status = "M";
            pbrow.sortkey_status = 10;
          }
        } else if (e.pushback_confirmation_status === "VERIFIED") {
          pbrow.status = "V";
        } else if (e.pushback_confirmation_status === "MISMATCH") {
          pbrow.status = "M";
          pbrow.sortkey_status = 10;
        } else if (e.pushback_confirmation_status === "ABORT") {
          pbrow.status = "A";
          pbrow.sortkey_status = 11;
        }
        if (e.atc_last_update) {
          let sort_atc = e.atc_last_update.replace("T", " ");
          pbrow.sortkey_action = sort_atc;
        }

        if (e.driver_last_update) {
          let sort_driver = e.driver_last_update.replace("T", " ");
          pbrow.sortkey_driver = sort_driver;
        }

        if (pbrow.sortkey_action || pbrow.sortkey_driver) {
          if (pbrow.sortkey_action > pbrow.sortkey_driver) {
            pbrow.sortkey_action_date = pbrow.sortkey_action;
          } else if (pbrow.sortkey_driver > pbrow.sortkey_action) {
            pbrow.sortkey_action_date = pbrow.sortkey_driver;
          } else if (pbrow.sortkey_driver === pbrow.sortkey_action) {
            pbrow.sortkey_action_date = pbrow.sortkey_action;
          }
          // pbrow.sortkey_action_date = e.atc_last_update ? e.atc_last_update : e.driver_last_update;
        }

        //set instruction button text and css class name
        let pbinstructiondtls = pushbackMapping.data.filter(
          (i) => i.bay == e.current_parkingstand
        );
        if (pbinstructiondtls.length > 0) {
          pbrow.gmc = pbinstructiondtls[0].gmc;
          pbrow.app_pushback_instruction_1 =
            pbinstructiondtls[0].app_pushback_instruction_1;
          pbrow.app_pushback_instruction_2 =
            pbinstructiondtls[0].app_pushback_instruction_2;
          pbrow.app_pushback_instruction_3 =
            pbinstructiondtls[0].app_pushback_instruction_3;
          pbrow.app_pushback_instruction_1_class_name = "button-default";
          pbrow.app_pushback_instruction_2_class_name = "button-default";
          pbrow.app_pushback_instruction_3_class_name = "button-default";
          pbrow.app_pushback_disabled_1_class_name = "button-default";
          pbrow.app_pushback_disabled_2_class_name = "button-default";
          pbrow.app_pushback_disabled_3_class_name = "button-default";

          if (
            pbrow.app_pushback_instruction_1 ===
              pbrow.pushback_instruction_atc &&
            pbrow.app_pushback_instruction_1 ===
              pbrow.pushback_instruction_driver
          ) {
            pbrow.app_pushback_instruction_1_class_name = "button-match";
          } else if (
            pbrow.app_pushback_instruction_1 === pbrow.pushback_instruction_atc
          ) {
            pbrow.app_pushback_instruction_1_class_name = "button-atc";
            //disabled
            pbrow.app_pushback_disabled_2_class_name =
              "atc-page-instruction-disabled";
            pbrow.app_pushback_disabled_3_class_name =
              "atc-page-instruction-disabled";
          } else if (
            pbrow.app_pushback_instruction_1 ===
            pbrow.pushback_instruction_driver
          ) {
            pbrow.app_pushback_instruction_1_class_name = "button-driver";
          }

          if (
            pbrow.app_pushback_instruction_2 ===
              pbrow.pushback_instruction_atc &&
            pbrow.app_pushback_instruction_2 ===
              pbrow.pushback_instruction_driver
          ) {
            pbrow.app_pushback_instruction_2_class_name = "button-match";
          } else if (
            pbrow.app_pushback_instruction_2 === pbrow.pushback_instruction_atc
          ) {
            pbrow.app_pushback_instruction_2_class_name = "button-atc";
            //disabled
            pbrow.app_pushback_disabled_1_class_name =
              "atc-page-instruction-disabled";
            pbrow.app_pushback_disabled_3_class_name =
              "atc-page-instruction-disabled";
          } else if (
            pbrow.app_pushback_instruction_2 ===
            pbrow.pushback_instruction_driver
          ) {
            pbrow.app_pushback_instruction_2_class_name = "button-driver";
          }

          if (
            pbrow.app_pushback_instruction_3 ===
              pbrow.pushback_instruction_atc &&
            pbrow.app_pushback_instruction_3 ===
              pbrow.pushback_instruction_driver
          ) {
            pbrow.app_pushback_instruction_3_class_name = "button-match";
          } else if (
            pbrow.app_pushback_instruction_3 === pbrow.pushback_instruction_atc
          ) {
            pbrow.app_pushback_instruction_3_class_name = "button-atc";

            //disabled
            pbrow.app_pushback_disabled_1_class_name =
              "atc-page-instruction-disabled";
            pbrow.app_pushback_disabled_2_class_name =
              "atc-page-instruction-disabled";
          } else if (
            pbrow.app_pushback_instruction_3 ===
            pbrow.pushback_instruction_driver
          ) {
            pbrow.app_pushback_instruction_3_class_name = "button-driver";
          }
        }

        pbrow.searchstr = (pbrow.call_sign + pbrow.bay).toLowerCase();
        pbrow.sortkey_tsat = e.startupapproval_date + e.startupapproval_time;
        return pbrow;
      });

      console.log("pbdata", pbdata);
      setOriginalPushbackData(pbdata);
      setLoading(false);
    }
  }, [gatesData]);

  useEffect(() => {
    if (originalPushbackData.length > 0) {
      filterData();
    }
  }, [
    originalPushbackData,
    gmcAllChecked,
    gmc1Checked,
    gmc2Checked,
    gmc3Checked,
    gmc4Checked,
    gmc5Checked,
    gmc6Checked,
    sortKey,
    searchValue,
  ]);

  useEffect(() => {
    if (userGMC) {
      // if (userGMC.gmcAllChecked) {
      //   setGMCAllChecked(true)
      // }
      if (userGMC.gmc1Checked) {
        setGMC1Checked(true);
      }
      if (userGMC.gmc2Checked) {
        setGMC2Checked(true);
      }
      if (userGMC.gmc3Checked) {
        setGMC3Checked(true);
      }
      if (userGMC.gmc4Checked) {
        setGMC4Checked(true);
      }
      if (userGMC.gmc5Checked) {
        setGMC5Checked(true);
      }
      if (userGMC.gmc6Checked) {
        setGMC6Checked(true);
      }
    }
  }, [userGMC]);

  useEffect(() => {
    // if (gmcAllChecked || gmc1Checked || gmc2Checked || gmc4Checked || gmc5Checked || gmc6Checked) {
    if (
      gmc1Checked ||
      gmc2Checked ||
      gmc4Checked ||
      gmc5Checked ||
      gmc6Checked
    ) {
      //get gate local storage
      let existingFilterQuery = window.localStorage.getItem("filterQuery");
      existingFilterQuery = existingFilterQuery
        ? JSON.parse(existingFilterQuery)
        : {};

      // store updated selected gate
      // existingFilterQuery = { gmcAllChecked, gmc1Checked, gmc2Checked, gmc3Checked, gmc4Checked, gmc5Checked, gmc6Checked };
      existingFilterQuery = {
        gmc1Checked,
        gmc2Checked,
        gmc3Checked,
        gmc4Checked,
        gmc5Checked,
        gmc6Checked,
      };

      //set selected gate if there is existing data in localstorage
      setUserGMC(existingFilterQuery);
      window.localStorage.setItem(
        "filterQuery",
        JSON.stringify(existingFilterQuery)
      );

      // console.log("STORE NEW GATE", existingFilterQuery);
    }
  }, [
    // gmcAllChecked,
    gmc1Checked,
    gmc2Checked,
    gmc3Checked,
    gmc4Checked,
    gmc5Checked,
    gmc6Checked,
  ]);

  // check internet connection
  useEffect(() => {
    setInterval(() => {
      var condition = navigator.onLine ? "online" : "offline";
      // console.log('NAVIGATOR ONLINE', navigator.onLine);
      if (condition === "online") {
        setCheckConnection(false);
      } else {
        console.log("OFFLINE");
        setCheckConnection(true);
      }
    }, 60000);
  }, []);

  // check user token validity
  useEffect(() => {
    console.log("TTime SESSION New");
    checkTimeSessionToken();
    setInterval(() => {
      checkTimeSessionToken();
      reloadPage();
    }, 2700000); //2400000 this will check every 45mins
  }, []);

  useEffect(() => {
    if (errorSessionDisplay) {
      checkAtcoTokenValidity();
      setTimeout(() => {
        reloadPage();
        checkAtcoTokenValidity();
      }, 180000);
    }
  }, []);

  const filterData = () => {
    let newPushbackData = [];
    if (gmc1Checked) {
      let filteredGatesData = originalPushbackData.filter(
        (item) => item.gmc === "GC1E"
      );
      newPushbackData = newPushbackData.concat(filteredGatesData);
    }
    if (gmc2Checked) {
      let filteredGatesData = originalPushbackData.filter(
        (item) => item.gmc === "GC1W"
      );
      newPushbackData = newPushbackData.concat(filteredGatesData);
    }
    if (gmc3Checked) {
      let filteredGatesData = originalPushbackData.filter(
        (item) => item.gmc === "GC2"
      );
      newPushbackData = newPushbackData.concat(filteredGatesData);
    }
    if (gmc4Checked) {
      let filteredGatesData = originalPushbackData.filter(
        (item) => item.gmc === "GC3"
      );
      newPushbackData = newPushbackData.concat(filteredGatesData);
    }
    if (gmc5Checked) {
      let filteredGatesData = originalPushbackData.filter(
        (item) => item.gmc === "GC4E"
      );
      newPushbackData = newPushbackData.concat(filteredGatesData);
    }
    if (gmc6Checked) {
      let filteredGatesData = originalPushbackData.filter(
        (item) => item.gmc === "GC4W"
      );
      newPushbackData = newPushbackData.concat(filteredGatesData);
    }

    if (
      newPushbackData.length === 0 &&
      !gmc1Checked &&
      !gmc2Checked &&
      !gmc3Checked &&
      !gmc4Checked &&
      !gmc5Checked &&
      !gmc6Checked
    ) {
      newPushbackData = originalPushbackData;
    }

    if (searchValue) {
      newPushbackData = newPushbackData.filter((item) =>
        item.searchstr.includes(searchValue.toLowerCase())
      );
    }

    newPushbackData = sortByKey(newPushbackData, "sortkey_tsat", false);

    if (sortKey === "S") {
      console.log("sortKey", sortKey);
      let newdata = [...newPushbackData];
      newPushbackData = sortByKey(newdata, "sortkey_status", true);
    } else if (sortKey === "A") {
      console.log("sortKey", sortKey);
      let newdata = [...newPushbackData];
      newPushbackData = sortByKey(newdata, "sortkey_action_date", true);
      // console.log("newPushbackData action", newdata);
    } else if (sortKey === "T") {
      console.log("sortKey", sortKey);
      let newdata = [...newPushbackData];

      newPushbackData = sortByKey(
        sortByKey(newdata, "bay"),
        "sortkey_tsat",
        false
      );
    }

    // console.log("newPushbackData", newPushbackData);
    setPushbackData(newPushbackData);
    setLoading(false);
  };

  const showAtcoInfoModal = () => {
    setInfoModalVisibility(true);
  };

  const closeAtcoInfoModal = () => {
    setInfoModalVisibility(false);
  };

  const checkAtcoTokenValidity = () => {
    // call refresh token
    let poolData = {
      UserPoolId: constants.USERPOOLID,
      ClientId: constants.CLIENTID,
    };
    let userPool = new CognitoUserPool(poolData);
    const cognitoAtco = userPool.getCurrentUser();
    if (
      cognitoAtco.username === userLocal.idToken.payload["cognito:username"] &&
      userLocal.idToken.payload["custom:role"] === "atco"
    ) {
      cognitoAtco.getSession(function (err, data) {
        if (err) {
          // Prompt the user to reauthenticate by hand...
          props.history.push("/");
        } else {
          const cognitoAtcoSession = data;
          const yourAccessToken = cognitoAtcoSession.getAccessToken().jwtToken;
          // const yourIdToken = cognitoAtcoSession.getIdToken().jwtToken;
          let refresh_token = cognitoAtcoSession.getRefreshToken();

          // setup AWS config
          AWS.config.credentials = new AWS.CognitoIdentityCredentials(
            {
              IdentityPoolId: "",
              Logins: {
                [constants.LOGINS]: yourAccessToken,
              },
            },
            {
              region: "ap-southeast-1",
            }
          );
          if (AWS.config.credentials.needsRefresh()) {
            cognitoAtco.refreshSession(
              refresh_token,
              (refErr, cognitoAtcoSession) => {
                //this provide new accessToken, IdToken, refreshToken
                // you can add you code here once you get new accessToken, IdToken, refreshToken
                if (refErr) {
                  // throw refErr;
                  console.log("TTime error", refErr);
                } else {
                  // console.log("TTime NEW SESSION", cognitoAtcoSession);
                  AWS.config.credentials.params.Logins[
                    constants.LOGINS
                  ] = cognitoAtcoSession.getAccessToken().jwtToken;

                  // // //get existing local storage
                  let existingLocalStorage = window.localStorage.getItem(
                    "atcoToken"
                  );
                  let accessTokenLocalStorage = localStorage.getItem(
                    "accessToken"
                  );

                  // If no existing data, create an array
                  // Otherwise, convert the localStorage string to an array
                  existingLocalStorage = existingLocalStorage
                    ? JSON.parse(existingLocalStorage)
                    : {};
                  accessTokenLocalStorage = accessTokenLocalStorage
                    ? accessTokenLocalStorage
                    : "";

                  // store new session in localStorage
                  existingLocalStorage = cognitoAtcoSession;
                  accessTokenLocalStorage = cognitoAtcoSession.getAccessToken()
                    .jwtToken;

                  // Save back to localStorage
                  setUserLocal(existingLocalStorage);
                  localStorage.setItem(
                    "atcoToken",
                    JSON.stringify(existingLocalStorage)
                  );
                  localStorage.setItem("accessToken", accessTokenLocalStorage);

                  // add new session to the store
                  dispatch(updateUser(cognitoAtcoSession));
                  // console.log("TTIME TODAY", moment().format('HH:mm:ss'));
                  // console.log("TTIME UNIX", moment.unix(userLocal.idToken.payload.exp).format('MMMM Do YYYY hh:mm:ss A'));

                  // console.log("TTTime AWS.config.credentials", AWS.config.credentials);
                  // AWS.config.credentials.refresh(err => {
                  //   if (err) {
                  //     console.log(err);
                  //   } else {
                  //     console.log('TTIME TOKEN SUCCESSFULLY UPDATED');
                  //   }
                  // });
                }
              }
            );
          }
        }
      });
    }
  };

  //check time interval function
  const checkTimeSessionToken = () => {
    let today = moment().unix();
    let expirationTime = moment
      .unix(userLocal.idToken.payload.exp);

    if (today < expirationTime) {
      // console.log("TTIME THERE IS NO TIME LEFT");
      checkAtcoTokenValidity();
    } else {
      console.log("TIME THERE IS TIME LEFT");
      // logoutUser();
      setErrorSessionDisplay(true);
    }
  };

  const reloadPage = () => {
    window.location.reload();
  };

  const showLoadingDesign = (bay, instruction) => {
    setSelectedBay(bay);
    setSelectedClass(instruction);
  };

  const focusRef = (bay, instruction) => {
    if (selectedBay === bay && selectedClass === instruction) {
      ref_pushback_instruction.current.focus();
      // console.log("focuuus");
    }
  };

  const logoutUser = () => {
    dispatch(wsDisconnect()); //disconnect websocket
    dispatch(updateUser(null)); //logout -> clear user data
    window.localStorage.removeItem("accessToken");
    window.localStorage.removeItem("atcoToken");
    window.localStorage.removeItem("filterQuery");
    props.history.push("/");
  };

  return (
    <React.Fragment>
      {/* {!wsOpened && (
        <div className="alert_notice">
          <Alert
            message="Retrieving latest flight and pushback data. Please reload the page if it failed to retrieve latest flights."
            type="error"
            className="alert_error"
          />
        </div>
      )} */}

      {!wsOpened ? (
        <div className="alert_notice">
          <Alert
            message="Retrieving latest flight and pushback data. Please reload the page if it failed to retrieve latest flights."
            type="error"
            className="alert_error"
          />
        </div>
      ) : !wsOpened && errorDisplay ? (
        <div className="alert_notice">
          <Alert
            message="Error retrieving latest flight and pushback data. Please reload the page and try again."
            type="error"
            className="alert_error"
          />
        </div>
      ) : (
        <span />
      )}

      {errorSessionDisplay && (
        <div className="alert_notice">
          <Alert
            message="Session is almost over. Please reload the page to start new session."
            type="error"
            className="alert_error"
          />
        </div>
      )}
      {/* {(!wsOpened && errorDisplay) && (
        <div className="alert_notice">
          <Alert message="Error retrieving latest flight and pushback data. Please reload the page and try again." type="error" className="alert_error" />
        </div>
      )} */}
      {checkConnection && (
        <div className="alert_notice">
          <Alert
            message="Error retrieving latest flight and pushback data. Check internet connection and try again."
            type="error"
            className="alert_error"
          />
        </div>
      )}
      {/* display offline message (if internet gets disconnected) */}
      {/* <Offline>
        <div className="alert_notice">
          <Alert message="Error retrieving latest flight and pushback data. Check internet connection and try again." type="error" className="alert_error" />
        </div>
      </Offline> */}
      {/* **** */}
      <div className="Appbar">
        <Row type="flex" justify="space-between" align="middle">
          <Col>
            <Button type="link" style={{ color: `${variables.appColor}` }}>
              <img
                src={icon_profile_svg}
                alt="icon_user"
                style={{
                  marginRight: 10,
                  position: "relative",
                  top: -2,
                  width: "15px",
                }}
              />
              {user
                ? user.idToken.payload.name
                : userLocal.idToken.payload.name}
            </Button>
            <Divider type="vertical" style={styles.divider} />
            <Button
              type="link"
              style={{ color: `${variables.appColor}` }}
              onClick={showAtcoInfoModal}
            >
              <img
                src={icon_information_svg}
                alt="icon_info"
                style={{
                  marginRight: 5,
                  position: "relative",
                  top: "-2px",
                  width: "15px",
                }}
              />
              Information
            </Button>
            <Divider type="vertical" style={styles.divider} />
            <Button
              type="link"
              style={{ color: `${variables.appColor}` }}
              onClick={logoutUser}
            >
              Log Out
            </Button>
          </Col>
          <Input
            size="small"
            placeholder="Call Sign / Bay"
            suffix={<SearchOutlined />}
            onChange={(e) => setSearchValue(e.target.value)}
            style={{
              width: 200,
              backgroundColor: `${variables.appBackgroundColor}`,
            }}
          />
        </Row>
        <Row
          type="flex"
          align="middle"
          style={{ margin: "30px 10px 10px 10px" }}
        >
          <Col span={14}>
            <Row type="flex" justify="space-between">
              <Checkbox checked={gmc1Checked} setChecked={setGMC1Checked}>
                GC1E
              </Checkbox>
              <Checkbox checked={gmc2Checked} setChecked={setGMC2Checked}>
                GC1W
              </Checkbox>
              <Checkbox checked={gmc3Checked} setChecked={setGMC3Checked}>
                GC2
              </Checkbox>
              <Checkbox checked={gmc4Checked} setChecked={setGMC4Checked}>
                GC3
              </Checkbox>
              <Checkbox checked={gmc5Checked} setChecked={setGMC5Checked}>
                GC4E
              </Checkbox>
              <Checkbox checked={gmc6Checked} setChecked={setGMC6Checked}>
                GC4W
              </Checkbox>
            </Row>
          </Col>
          <Col span={10}>
            <Row type="flex" justify="end">
              <Radio.Group
                style={{ fontSize: 12 }}
                buttonStyle="solid"
                defaultValue="S"
                onChange={(e) => setSortKey(e.target.value)}
              >
                <Radio.Button value="S">Status</Radio.Button>
                <Radio.Button value="A">Action</Radio.Button>
                <Radio.Button value="T">TSAT</Radio.Button>
              </Radio.Group>
            </Row>
          </Col>
        </Row>
      </div>

      <div style={styles.container}>
        <Row
          style={{
            textAlign: "center",
            padding: "0px 10px 10px 10px",
            fontSize: 14,
            fontWeight: "normal",
          }}
        >
          <Col span={4}>CALL SIGN</Col>
          <Col span={3}>BAY</Col>
          <Col span={15}>
            <Row>
              <Col span={6} style={{ paddingLeft: "9px" }}>
                PUSHBACK
              </Col>
            </Row>
          </Col>
          <Col span={2}>TSAT</Col>
        </Row>

        <FlipMove duration={700} staggerDurationBy={100}>
          {pushbackData &&
            pushbackData.map((pbdata, index) => (
              <Row
                type="flex"
                key={pbdata.bay}
                style={styles.row}
                align="middle"
              >
                <Col span={4}>
                  <Row type="flex" align="middle">
                    {(pbdata.status === "M" ||
                      pbdata.status === "C" ||
                      pbdata.status === "A") && (
                      <Col
                        span={1}
                        style={{
                          background: "#FFEB33",
                          height: `${variables.appRowHeight}`,
                        }}
                      ></Col>
                    )}
                    {pbdata.status != "M" &&
                      pbdata.status != "C" &&
                      pbdata.status != "A" && (
                        <Col
                          span={1}
                          style={{
                            background: "#2B2C41",
                            height: `${variables.appRowHeight}`,
                          }}
                        ></Col>
                      )}
                    <Col span={10}>
                      {pbdata.pushback_confirmation_status === "ABORT" && (
                        <img
                          alt="icon_stop"
                          src={icon_stop_svg}
                          style={{ margin: "0 10px", cursor: "pointer" }}
                          onClick={() => {
                            let data = {
                              action:
                                constants.ACTION_UPDATE_VALIDATE_INSTRUCTION,
                              instruction: {
                                gate: pbdata.bay,
                                pushback_direction: "ABORT",
                              },
                              access_token: user.accessToken.jwtToken,
                            };
                            console.log("data", data);
                            dispatch(wsSend(data));
                          }}
                        />
                      )}
                      {pbdata.pushback_confirmation_status != "ABORT" && (
                        <img
                          alt="icon_stop_inactive"
                          src={icon_stop_inactive_svg}
                          style={{ margin: "0 10px", cursor: "pointer" }}
                          onClick={() => {
                            let data = {
                              action:
                                constants.ACTION_UPDATE_VALIDATE_INSTRUCTION,
                              instruction: {
                                gate: pbdata.bay,
                                pushback_direction: "ABORT",
                              },
                              access_token: user.accessToken.jwtToken,
                            };
                            console.log("data", data);
                            dispatch(wsSend(data));
                          }}
                        />
                      )}
                    </Col>
                    <Col span={13} style={{ textAlign: "left" }}>
                      {pbdata.call_sign}
                    </Col>
                  </Row>
                </Col>

                <Col span={3}>
                  <Row type="flex" align="middle">
                    <Divider type="vertical" style={styles.divider} />
                    <img
                      src={icon_anchor}
                      alt="icon_anchor"
                      style={{
                        marginRight: 7,
                        marginLeft: 7,
                        height: 12,
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        window.open(
                          //constants.CHANGIGMC_URL + pbdata.bay.toLowerCase()
                          "#/pbr?bay=" + pbdata.bay.toLowerCase(),
                          "_blank"
                        )
                      }
                    />
                    {pbdata.bay}
                  </Row>
                </Col>

                <Col span={15} style={{ textAlign: "left" }}>
                  <Row type="flex" justify="start">
                    {pbdata.app_pushback_instruction_1 && (
                      <Button
                        size="large"
                        // ref={ref_pushback_instruction}
                        // className={pbdata.app_pushback_instruction_1_class_name}
                        // className={`${
                        //   selectedBay === pbdata.bay &&
                        //   selectedClass === pbdata.app_pushback_instruction_1
                        //     ? "button-loading"
                        //     : "button-loading-after"
                        // } ${pbdata.app_pushback_disabled_1_class_name} ${
                        //   pbdata.app_pushback_instruction_1_class_name
                        // }`}
                        className={`${
                          selectedBay === pbdata.bay &&
                          selectedClass === pbdata.app_pushback_instruction_1 &&
                          loading
                            ? "loading_btn"
                            : ""
                        } ${pbdata.app_pushback_disabled_1_class_name} ${
                          pbdata.app_pushback_instruction_1_class_name
                        }`}
                        onMouseDown={(e) => e.target.classList.add("pressed")}
                        onMouseUp={(e) => e.target.classList.remove("pressed")}
                        onTouchStart={(e) => e.target.classList.add("pressed")}
                        onTouchEnd={(e) => e.target.classList.remove("pressed")}
                        disabled={
                          (pbdata.app_pushback_disabled_1_class_name ===
                            "atc-page-instruction-disabled" &&
                            pbdata.status !== "A" &&
                            pbdata.status !== "C") ||
                          pbdata.status === "V"
                        }
                        onClick={() => {
                          setLoading(true);
                          showLoadingDesign(
                            pbdata.bay,
                            pbdata.app_pushback_instruction_1
                          );
                          console.log(
                            "data2",
                            pbdata.app_pushback_instruction_1
                          );
                          let data = {
                            action:
                              constants.ACTION_UPDATE_VALIDATE_INSTRUCTION,
                            instruction: {
                              gate: pbdata.bay,
                              pushback_direction:
                                pbdata.app_pushback_instruction_1,
                            },
                            access_token: user.accessToken.jwtToken,
                          };
                          console.log("data", data);
                          dispatch(wsSend(data));
                        }}
                      >
                        <span
                          className={`${
                            pbdata.app_pushback_instruction_1.length >= 15
                              ? "long_text"
                              : ""
                          }`}
                        >
                          {pbdata.app_pushback_instruction_1}
                        </span>
                      </Button>
                    )}
                    {pbdata.app_pushback_instruction_2 && (
                      <Button
                        size="large"
                        // ref={ref_pushback_instruction}
                        // className={pbdata.app_pushback_instruction_2_class_name}
                        // className={`${
                        //   selectedBay === pbdata.bay &&
                        //   selectedClass === pbdata.app_pushback_instruction_2
                        //     ? "button-loading"
                        //     : "button-loading-after"
                        // }  ${pbdata.app_pushback_disabled_2_class_name}  ${
                        //   pbdata.app_pushback_instruction_2_class_name
                        // }`}
                        className={`${
                          selectedBay === pbdata.bay &&
                          selectedClass === pbdata.app_pushback_instruction_2 &&
                          loading
                            ? "loading_btn"
                            : ""
                        } ${pbdata.app_pushback_disabled_2_class_name} ${
                          pbdata.app_pushback_instruction_2_class_name
                        }`}
                        onMouseDown={(e) => e.target.classList.add("pressed")}
                        onMouseUp={(e) => e.target.classList.remove("pressed")}
                        onTouchStart={(e) => e.target.classList.add("pressed")}
                        onTouchEnd={(e) => e.target.classList.remove("pressed")}
                        disabled={
                          (pbdata.app_pushback_disabled_2_class_name ===
                            "atc-page-instruction-disabled" &&
                            pbdata.status !== "A" &&
                            pbdata.status !== "C") ||
                          pbdata.status === "V"
                        }
                        onClick={() => {
                          setLoading(true);
                          showLoadingDesign(
                            pbdata.bay,
                            pbdata.app_pushback_instruction_2
                          );
                          // focusRef(
                          //   pbdata.bay,
                          //   pbdata.app_pushback_instruction_2
                          // );
                          console.log(
                            "data2",
                            pbdata.app_pushback_instruction_2
                          );
                          let data = {
                            action:
                              constants.ACTION_UPDATE_VALIDATE_INSTRUCTION,
                            instruction: {
                              gate: pbdata.bay,
                              pushback_direction:
                                pbdata.app_pushback_instruction_2,
                            },
                            access_token: user.accessToken.jwtToken,
                          };
                          console.log("data", data);
                          dispatch(wsSend(data));
                        }}
                      >
                        <span
                          className={`${
                            pbdata.app_pushback_instruction_2.length >= 15
                              ? "long_text"
                              : ""
                          }`}
                        >
                          {pbdata.app_pushback_instruction_2}
                        </span>
                      </Button>
                    )}
                    {pbdata.app_pushback_instruction_3 && (
                      <Button
                        // ref={ref_pushback_instruction}
                        size="large"
                        // className={pbdata.app_pushback_instruction_3_class_name}
                        // className={`${
                        //   selectedBay === pbdata.bay &&
                        //   selectedClass === pbdata.app_pushback_instruction_3
                        //     ? "button-loading"
                        //     : "button-loading-after"
                        // } ${pbdata.app_pushback_disabled_3_class_name} ${
                        //   pbdata.app_pushback_instruction_3_class_name
                        // } `}
                        className={`${
                          selectedBay === pbdata.bay &&
                          selectedClass === pbdata.app_pushback_instruction_3 &&
                          loading
                            ? "loading_btn"
                            : ""
                        } ${pbdata.app_pushback_disabled_3_class_name} ${
                          pbdata.app_pushback_instruction_3_class_name
                        }`}
                        onMouseDown={(e) => e.target.classList.add("pressed")}
                        onMouseUp={(e) => e.target.classList.remove("pressed")}
                        onTouchStart={(e) => e.target.classList.add("pressed")}
                        onTouchEnd={(e) => e.target.classList.remove("pressed")}
                        disabled={
                          (pbdata.app_pushback_disabled_3_class_name ===
                            "atc-page-instruction-disabled" &&
                            pbdata.status !== "A") ||
                          pbdata.status === "V"
                        }
                        onClick={() => {
                          setLoading(true);
                          showLoadingDesign(
                            pbdata.bay,
                            pbdata.app_pushback_instruction_3
                          );
                          // focusRef(
                          //   pbdata.bay,
                          //   pbdata.app_pushback_instruction_3
                          // );
                          console.log(
                            "data2",
                            pbdata.app_pushback_instruction_3
                          );
                          let data = {
                            action:
                              constants.ACTION_UPDATE_VALIDATE_INSTRUCTION,
                            instruction: {
                              gate: pbdata.bay,
                              pushback_direction:
                                pbdata.app_pushback_instruction_3,
                            },
                            access_token: user.accessToken.jwtToken,
                          };
                          console.log("data", data);
                          dispatch(wsSend(data));
                        }}
                      >
                        <span
                          className={`${
                            pbdata.app_pushback_instruction_3.length >= 15
                              ? "long_text"
                              : ""
                          }`}
                        >
                          {pbdata.app_pushback_instruction_3}
                        </span>
                      </Button>
                    )}
                    &nbsp;
                  </Row>
                </Col>

                <Col span={2} style={{ textAlign: "left" }}>
                  {pbdata.startupapproval_time}
                </Col>
              </Row>
            ))}
        </FlipMove>

        <ModalInformation
          infoModalVisibility={infoModalVisibility}
          closeAtcoInfoModal={closeAtcoInfoModal}
        />
      </div>

      <div style={{ paddingTop: 50, paddingBottom: 100, textAlign: "center" }}>
        <Row type="flex" justify="center">
          <img
            src={app_logo}
            alt="app_logo"
            style={{ width: 200, height: "100%" }}
          />
        </Row>
      </div>
    </React.Fragment>
  );
};

export default ATCO;
